import { copy, set } from 'cerebral/operators'

export default [
  copy('input:option', 'state:users.searchOptions.option'),
  set('users.searchOptions.showSnackbar', true)
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/selectSearchOption.js